const VTS = (window.vts = window.vts || {});

jQuery(function () {
  $("form[data-form-type=sign_up]")
    .bind("submit", function () {
      $("form[data-form-type=sign_up] .sign-up-button").prop("disabled", true);

      return $("form[data-form-type=sign_up] .spinners-container").show();
    })
    .bind("ajax:error", function (evt, data) {
      let errorMessage;

      if (data.responseJSON.error) {
        errorMessage = data.responseJSON.error;
      } else if (data.responseJSON.errors) {
        errorMessage =
          "Something went wrong with your registration. Please reach out to support@vts.com to register";
      }

      VTS.setNotificationMessage({
        message: errorMessage,
        selector: ".flash-message",
        type: "error",
      });

      $("form[data-form-type=sign_up] .sign-up-button").prop("disabled", false);

      return $("form[data-form-type=sign_up] .spinners-container").hide();
    })
    .bind("ajax:success", function () {
      $("form[data-form-type=sign_up]")
        .find(".sign-up-button, .fieldset.sign-up, .spinners-container")
        .hide();

      $(".flash-message")
        .html("<h2>Thank you!</h2><br>Please check your email <br>to confirm your account.")
        .show();

      return $("form[data-form-type=sign_up] .sign-up-button").prop("disabled", false);
    })
    .bind("ajax:before", function () {
      return VTS.removeNotificationMessage({
        selector: ".flash-message",
      });
    });

  return $("#user_persona").change(function () {
    if ($(`#${this.id} :selected[value!='']`).length > 0) {
      return $(`#${this.id}`).addClass("fieldset-input-select-selected");
    }

    return $(`#${this.id}`).removeClass("fieldset-input-select-selected");
  });
});
